module.exports = __webpack_public_path__ + "img/item_eating_1.5be4feea.jpg";